import React from 'react';
import PropTypes from 'prop-types';
import * as shapes from '../shapes';
import Footer from '../containers/Footer';
import ServicesTable from '../containers/ServicesTable';
import ServicesCategoryFilter from '../../../reports/filters/ServiceCategoryFilter';

const FormServices = ({
  handleSubmit,
  submitting,
  baseUrl,
  services,
  onDelete,
}) => (
  <div className="c-inner-wrapper u-pt u-br-12">
    <h2 className="c-heading c-heading--dark u-mb">Apply Rate to Services</h2>
    <div className="c-separator u-mt" />
    <div className="c-categories-filter">
      <ServicesCategoryFilter removeFilters={[]} />
    </div>
    <form onSubmit={handleSubmit}>
      <fieldset disabled={submitting}>
        <ServicesTable services={services} />
        <Footer baseUrl={baseUrl} onDelete={onDelete} />
      </fieldset>
    </form>
  </div>
);

FormServices.propTypes = {
  handleSubmit: shapes.handler,
  submitting: shapes.submitting,
  baseUrl: shapes.url,
  services: PropTypes.array.isRequired, // eslint-disable-line
  onDelete: PropTypes.func,
};

FormServices.defaultProps = {
  handleSubmit: () => null,
  submitting: false,
  baseUrl: '/settings/taxes',
  onDelete: null,
};

export default FormServices;
